export default "__VITE_ASSET__CkbaOFGy__"